module.exports = __webpack_public_path__ + "static/media/audi.3c9fa0a8.png";